import { Input } from "@chakra-ui/react";
import {
    PAYOUT_AUDIENCES,
    PAYOUT_MODES,
    PAYOUT_SESSION_KEYS,
    emptyPayoutAudiences,
} from "../../Config/ExpertPayoutPrices";

type PayoutPriceTablesProps = {
    value?: any;
    onChange: (
        audience: string,
        mode: string,
        sessionKey: string,
        fieldValue: string
    ) => void;
    disabled?: boolean;
};

const SESSION_LABELS: Record<string, string> = {
    "1session": "1 Session Price",
    "3session": "3 Session Price",
    "5session": "5 Session Price",
    "10session": "10 Session Price",
};

export const PayoutPriceTables = ({
    value,
    onChange,
    disabled = false,
}: PayoutPriceTablesProps) => {
    const sheet = { ...emptyPayoutAudiences(), ...(value || {}) };

    return (
        <div>
            {PAYOUT_MODES.map((mode) => (
                <div key={mode.value} className="mb-4">
                    <h6 className="mb-2">{mode.label}</h6>
                    <div className="table-responsive">
                        <table className="table table-sm mb-0">
                            <thead>
                                <tr>
                                    <th style={{ minWidth: "140px" }}>Audience</th>
                                    {PAYOUT_SESSION_KEYS.map((key) => (
                                        <th key={key}>{SESSION_LABELS[key]}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {PAYOUT_AUDIENCES.map((audience) => (
                                    <tr key={`${audience.value}-${mode.value}`}>
                                        <td className="align-middle">{audience.label}</td>
                                        {PAYOUT_SESSION_KEYS.map((key) => (
                                            <td key={key}>
                                                <Input
                                                    size="sm"
                                                    placeholder="Enter Price"
                                                    value={
                                                        sheet?.[audience.value]?.[mode.value]?.[key] || ""
                                                    }
                                                    onChange={(e) =>
                                                        onChange(
                                                            audience.value,
                                                            mode.value,
                                                            key,
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={disabled}
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
        </div>
    );
};